export interface UnitCases {
  unit: Units;
  cases: string[];
}

export type Units =
  | 'Inteligencia'
  | 'Asuntos Internos'
  | 'Asuntos Externos'
  | 'Gestión de Fraudes'
  | 'Supervision de OOFF';
export class TypeOfCases {
  private constructor() {}

  private static _units: Units[] = [
    'Inteligencia',
    'Asuntos Internos',
    'Asuntos Externos',
    'Gestión de Fraudes',
    'Supervision de OOFF',
  ];

  private static _cases: UnitCases[] = [
    {
      unit: 'Inteligencia',
      cases: [
        'Retención de fondos',
        'Gestión de casos VIP',
        'Suministro de información',
      ],
    },
    {
      unit: 'Asuntos Internos',
      cases: [
        'Investigación de asuntos internos',
        'Recuperación de fondos: cuenta externa',
      ],
    },

    {
      unit: 'Asuntos Externos',
      cases: [
        'Validar Documento',
        'Autorización de transacciones',
        'Validación de referencias',
        'Rol de Guardia',
        'Investigación Pre Empleo',
      ],
    },
    {
      unit: 'Gestión de Fraudes',
      cases: [
        'Detección y Análisis de Fraudes',
        'Gestión Administrativa de Fraudes',
      ],
    },
    {
      unit: 'Supervision de OOFF',
      cases: ['RAS'],
    },
  ];

  public static get unitAndCases(): UnitCases[] {
    return this._cases;
  }

  public static get units() {
    return this._units;
  }

  public static getCasesByUnit(units: Units[]) {
    let cases = [];
    for (const unit of units) {
      const unitCases = this._cases.find((unitCase) => unitCase.unit === unit);
      cases = cases.concat(unitCases.cases);
    }
    return cases;
  }
}
